import React from 'react'
import { Field as FormikField } from 'formik'

import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import ClipboardButton from 'react-clipboard.js'

import AutoSlugField from '../_library/AutoSlugField'
import Field from '../_library/Field'
import Card from '../_library/Card'
import RichTextArea from '../_library/RichTextArea'
import _get from 'lodash/get'
import { CustomToggleField } from '../formik/Fields'
import { ROLES } from '../constants/roles'

const BrandNameDetails = React.memo(props => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    brandUrlCopied,
    copyBrandUrlAfter,
    copyBrandUrlOut,
    handleChangeSlug,
    isRnDomain,
    handleChangeDescription,
    isNew,
    config,
    user,
  } = props

  const BASE_URL = _get(config, 'behavior.baseURL')
  const slugSuggestion = !isNew ? values.slug : values.displayName
  const isTfSupport = ROLES.is_tf_support(user.tfRole)
  const isTtfTeam = ROLES.is_ttf_team(user.tfRole)
  const isDisabled = !user.isSuperAdmin

  return (
    <Card icon={'fa-info'} title={'Brand Details'}>
      <Field
        id="displayName"
        label="Name"
        value={values.displayName}
        error={errors.displayName}
        touched={touched.displayName}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <label className="autoslugfield-label" onMouseLeave={copyBrandUrlOut}>
        URL
        <ClipboardButton
          component="span"
          data-clipboard-text={BASE_URL + values.slug}
          onSuccess={copyBrandUrlAfter}
        >
          <OverlayTrigger
            placement="right"
            overlay={
              brandUrlCopied ? (
                <Tooltip id="brandUrlCopied">Copied</Tooltip>
              ) : (
                <Tooltip id="brandUrlCopied">Copy Brand URL</Tooltip>
              )
            }
            trigger={['hover']}
          >
            <i className="fa fa-clipboard brand-url-copy" />
          </OverlayTrigger>
        </ClipboardButton>
      </label>
      <AutoSlugField
        id="slug"
        label="Link URL"
        separator={isRnDomain ? '' : '-'}
        hint="Letters, numbers and hyphens only"
        suggestion={slugSuggestion}
        value={values.slug}
        error={errors.slug}
        touched={touched.slug}
        onChange={handleChangeSlug}
      >
        <Field.PrefixAddon className="link-prefix hidden-xs">
          <img alt="no data" className="link-prefix-img" src={asset('/resources/images/event-url.png')} />
          <div className="link-prefix-url">{BASE_URL}</div>
        </Field.PrefixAddon>
      </AutoSlugField>
      {(isTfSupport || isTtfTeam || user.isSuperAdmin) && (
        <div className={`row ${isDisabled ? 'disabled' : ''}`} style={{ opacity: isDisabled ? 0.6 : 1 }}>
          <div className="col-xs-12 col-sm-6">
            <FormikField
              name="exclusive"
              onText="Make the Brand Exclusive"
              component={props => (
                <CustomToggleField
                  {...props}
                  subText="By enabling the toggle, the brand will automatically be marked as 'Verified', as well."
                />
              )}
              onChange={handleChange}
            />
          </div>
        </div>
      )}
      {isRnDomain ? (
        <div>
          <div className="div-spacing-20" />
          <RichTextArea
            label="Description (Links Allowed)"
            value={values.description}
            onChange={handleChangeDescription}
            editorStyle={errors.description && touched.description ? { border: '2px solid #d9534f' } : null}
          />
          <div className="div-spacing-20" />
          <Field
            id="shortDescription"
            label="Short Description (max 150 characters)"
            value={values.shortDescription}
            error={errors.shortDescription}
            touched={touched.shortDescription}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
      ) : null}
    </Card>
  )
})

export default BrandNameDetails
